import { AxiosRequestConfig } from 'axios';
import { BASE_UAPI_URL } from '../../constants/commonStrings.constant';
import { apiService } from '../api.service';
import createQueryParams from '@/util/queryParams';


type DeleteRolesPathParams = {
  /**
   * @description roleid
   * @type string
   */
  roleid: string;
};

type GetRolesPathParams = {
  roleid: number;
}

type PostRolesMutationRequest = {
  /**
   * @description C U cg
   */
  permssionSet?: | undefined;
  /**
   * @description C U
   * @type string | undefined
   */
  roledesc?: string | undefined;
  /**
   * @description P Gc
   * @type integer | undefined
   */
  roleid?: number | undefined;
  /**
   * @description P C U
   * @type string | undefined
   */
  rolename?: string | undefined;
  /**
   * @type integer | undefined
   */
  scopeTypeId?: number | undefined;
  /**
   * @description (kwt 12/03/2022) added Scope Type fields.
   * @type string | undefined
   */
  scopeTypeName?: string | undefined;
}

const PermissionService = () => {

  const getPermissions = async (
    // params: GetPermissionsPathParams,
    config?: Partial<AxiosRequestConfig>,
    signal?: AbortSignal,
  ): Promise<any> => {
    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/permissions',
      ...config,
      signal,
    });
  };

  const getRoleId = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: Function;
    onError?: Function;
  }) => {
    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/roleid',
      onSuccess,
      onError,
    });
  };

  const getRoles = async ({
    onSuccess,
    onError,
  }: {
    onSuccess?: Function;
    onError?: Function;
  }) => {
    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/roles',
      onSuccess,
      onError,
    });
  };


  const getRoleById = async (
    params: GetRolesPathParams,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    // const { roleid } = params;
    const search = createQueryParams(params);
    console.log('search : ', search)
    const requestId = `getRoleById_${Date.now()}`;
    const response = await apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/roles' + search,
      ...config,
      id: requestId,
    });
    return response;
  };

  const getPermissionsFlags = async (
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/permissionsflags',
      ...config,
    });
  };

  const getPermissionsList = async (
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    return apiService({
      method: 'get',
      url: BASE_UAPI_URL + '/permissionslist',
      ...config,
    });
  };

  const createRole = async (
    data: PostRolesMutationRequest,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    return apiService({
      method: 'post',
      url: BASE_UAPI_URL + '/roles',
      data,
      ...config,
    });
  };

  const updateRole = async (
    data: PostRolesMutationRequest,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    return apiService({
      method: 'post',
      url: BASE_UAPI_URL + '/updaterole',
      data,
      ...config,
    });
  };

  const deleteRole = async (
    params: DeleteRolesPathParams,
    config?: Partial<AxiosRequestConfig>,
  ): Promise<any> => {
    const { roleid } = params;
    const search = createQueryParams({ roleid });
    return apiService({
      method: 'delete',
      url: BASE_UAPI_URL + '/roles' + search,
      ...config,
    });
  };


  return {
    getPermissions,
    getRoleId,
    getRoles,
    getRoleById,
    getPermissionsFlags,
    getPermissionsList,
    createRole,
    updateRole,
    deleteRole
  };
};

export default PermissionService;
